<mat-toolbar>
    <mat-toolbar-row #toolbarRow>
      <ng-template ngFor let-route="$implicit" [ngForOf]="routes">
        <a
          mat-button
          [routerLink]="route.path"
          [routerLinkActive]="['mat-button-toggle-checked', 'active-route']"
          #rla="routerLinkActive"
        >
          {{ route.label }}</a
        >
      </ng-template>
  
      <a mat-button class="ml-auto">{{ user.username }}</a>
    </mat-toolbar-row>
</mat-toolbar>

<router-outlet></router-outlet>
